import { useState, useEffect, useContext } from "react";
import { GlobalStates } from "../GlobalStates";
import { useTranslation } from "react-i18next";
import PrimaryAccordion2 from "../Components/PrimaryAccordion/PrimaryAccordionUser";
import PrimaryButton from "../Components/Button/PrimaryButton";
import { CompanyFilter } from "../Components/CompanyFilter";
import { Link } from 'react-router-dom';
import { useSupabaseData } from "../Hooks";
import { useUser } from "../Hooks";

const Users = () => {
    const { path } = useContext(GlobalStates)
    const { t } = useTranslation()
    const { users: info, getAllUsers } = useUser(path);
    const { data: atsakymai, DELETE: deleteAts } = useSupabaseData({ name: 'atsakymai' });
    const { data: formos, DELETE: deleteFrom } = useSupabaseData({ name: 'formos' });
    const [filteredInfo, setFilteredInfo] = useState([])
    const [statusFilter, setStatusFilter] = useState('')

    useEffect(() => { getAllUsers() }, [])



    useEffect(() => {
        if (atsakymai && atsakymai.length > 0 && deleteAts)
            atsakymai.map((e) => { deleteAts(e.id); return e; })
        if (formos && formos.length > 0 && deleteFrom)
            formos.map((e) => { deleteFrom(e.id); return e; })
        getAllUsers()
    }, [atsakymai, formos, deleteAts, deleteFrom, getAllUsers])
    
    // Filter companies based on status filter
    useEffect(() => {
        if (!info || info.length === 0) {
            setFilteredInfo([]);
            return;
        }
        
        let filtered = [...info];
        
        // Apply status filter
        if (statusFilter) {
            switch (statusFilter) {
                case 'active':
                    filtered = filtered.filter(item => 
                        item.confirmed === true
                    );
                    break;
                case 'not_confirmed':
                    filtered = filtered.filter(item => item.confirmed !== true);
                    break;
                default:
                    break;
            }
        }
        
        setFilteredInfo(filtered);
    }, [info, statusFilter])
    const sorter = (arr => {
        arr.sort((a, b) => {
            // Pirmiausiai rūšiuoti pagal sukūrimo datą - naujausi viršuje
            if (a.createdAt && b.createdAt) {
                return new Date(b.createdAt) - new Date(a.createdAt)
            }
            // Jei nėra sukūrimo datos, naudoti validTo
            if (a.validTo && b.validTo) {
                return new Date(b.validTo) - new Date(a.validTo)
            }
            // Jei nėra datų, rūšiuoti pagal pavadinimą
            return (a.imonesPavadinimas || '').localeCompare(b.imonesPavadinimas || '')
        })

        return arr
    })
    // Handler for filter changes
    const handleFilterChange = (status) => {
        setStatusFilter(status);
    };

    return (
        <div className="Vartotojai standartPadding " >
            <div className="row name_action">
                <p className="accorcionName">{t('imones_label')}</p>
                <PrimaryButton
                    width={150}
                    component={Link}
                    to="/SukurtiImone"
                    text='create_imone'
                    variant="text"
                    className='nauja_apklausa'
                    onClick={() => { }}
                    sx={{
                        boxShadow: 0,':hover': {
                           
                            boxShadow:"1px 1px 5px lightgrey",
                             },
                     }}
                />
            </div>

            <CompanyFilter setFilter={handleFilterChange} />

            <PrimaryAccordion2
                elements={sorter(filteredInfo.length > 0 ? filteredInfo : info)}
                r={() => { getAllUsers() }}
            />

        </div>)
}
export default Users

